import React from 'react';
import { useQuery } from '@apollo/client';
import { getPublicQuizzes } from 'graphql/queries';
import { PublicQuizzes as Quizzes } from 'graphql/queries/types/PublicQuizzes';
import { ErrorLocal, QuizList, Spinner } from 'components';

interface Props {}

export const QuizSelector = (props: Props) => {
    const {
        loading,
        error,
        data: quizzesData
        // refetch
    } = useQuery<Quizzes>(getPublicQuizzes);

    if (loading) return <Spinner />;
    if (error) return <ErrorLocal errorMessage="Error getting quizzes :(" errorDetails={error} />;
    if (!quizzesData) return <p>No data</p>;


    return (
        <div className="aq-content">
            <QuizList quizList={quizzesData.quiz_master_quizzes} />
        </div>
    );
};
